const handleFaqAccordion = () => {
    const $accordionElements = document.querySelectorAll<HTMLDetailsElement>("[data-accordion]");
    $accordionElements.forEach($singleAccordion => {
        $singleAccordion.addEventListener("click", handleSingleAccordionClick)
    });
}

const handleSingleAccordionClick = (event: Event) => {
    const $clickedDetailsSummary = event.currentTarget as HTMLDetailsElement

    const $accordionElements = document.querySelectorAll<HTMLDetailsElement>("[data-accordion]");
    $accordionElements.forEach($singleAccordion => {

        if( $singleAccordion === $clickedDetailsSummary) {
            // console.log($clickedDetailsSummary)
        } else {
            $singleAccordion.open = false
        }
    });
}

handleFaqAccordion();